import React from "react";
import cookies from "js-cookies";
import { connect } from "react-redux";
import BaseComponent from "../BaseComponent";
import Result from './com.survay.result';
import './style.survey.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import QuestionList from "./com.questionList"
import { submitForm } from "./../../Actions/a.survey"
import { RotateCircleLoading } from 'react-loadingg';

class RequestForm extends BaseComponent {
  constructor() {
    super();
    this.state = {
      FormData: {
        City: '',
        Age: '',
        Gender: '0'
      },
      LoadingForm: true,
      Message: false,
      SubmitFormId: -1
    };

    //check if user submit in past
    //local storge value ==> 0: didn't submit , 1:Now user submit , 2: In the past user submitted
    if (cookies.getItem("UserStatus") === null) 
       cookies.setItem("UserStatus",0,undefined, "/", undefined, true); 
  }

  onSubmitForm(e) {
    e.preventDefault();
    let valid = true;
    let localState = this.state.FormData;
    let error = $('.errors__container');

    // form validate
    $(`div[class$="box"] input[type='text']`).removeClass('active');
    error.css('display', 'none');

    if (localState.City === '') {
      $(`div.city-box input[type='text']`).addClass('active');

      error.text('لطفا نام شهر خود را وارد کنید');
      error.css('display', 'block');
      valid = false;

    } else if (localState.Age === '') {

      $(`div.age-box input[type='number']`).addClass('active');

      error.text('لطفا سن خود را وارد کنید');
      error.css('display', 'block');
      valid = false;

    }
    else {
      var BreakException = {};
      try {
        this.props.Question.forEach(item => {
          $(`div.question-body[data-id='${item.Question.ID}']`).removeClass('active');

          let rows = this.props.Answer.find(row => row.QuestionId === item.Question.ID);
          if (rows == undefined) {// don't answerd this quesiton
            $(`div.question-body[data-id='${item.Question.ID}']`).addClass('active');
            var id = $(`div.question-body[data-id='${item.Question.ID}'] .question-title > span`).text().replace('-', '');
            error.text(`پاسخ سوال شماره  ${id}  را انتخاب کنید .`);
            error.css('display', 'block');
            valid = false;
          };
          if (!valid) throw BreakException;
        });
      }
      catch (e) {
        if (e !== BreakException) throw e;
      }

    }
    //if form valid to submit
    if (valid) {
      this.setState({ LoadingForm: false });
      let formData = {
        UserAnswers: this.props.Answer,
        City: localState.City,
        Age: localState.Age,
        Gender: localState.Gender
      };

      this.props.SubmitForm(formData).done((res) => {
        cookies.setItem("UserStatus",1,undefined, "/", undefined, true); 
        res !== -1 ? this.setState({ LoadingForm: true, Message: true, SubmitFormId: res }) : this.BindToast("خطایی رخ داده است. لطفا دقایقی بعد مجددا تلاش کنید.", 'error');
      });
    }
  }

  render() {
   var userStatus = cookies.getItem("UserStatus");
    return (
      <div className="from-box__container">
       { userStatus==="0"  ? 
          <React.Fragment>
            <ToastContainer />
            {this.state.Message === true ? <Result FormId={this.state.SubmitFormId} /> :
              <form id="form" onSubmit={(e) => this.onSubmitForm(e)}>
                {this.state.LoadingForm === false ? <div className="col-md-12"><RotateCircleLoading color="#c535b5" size="default" /></div> :
                  <div className="row">
                    <div className="col-md-4 city-box">
                      <div className="form-group">
                        <label>شهر :</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="شهر خود را وارد کنید"
                          data-validetta="required"
                          value={this.state.FormData.FirstName}
                          onChange={(e) => {
                            this.BindInput("FormData", "City", e.target);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 age-box">
                      <div className="form-group">
                        <label>سن :</label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="سن خود را وارد کنید"
                          data-validetta="required,number"
                          value={this.state.FormData.Age}
                          onChange={(e) => {
                            this.BindInput("FormData", "Age", e.target);
                          }}
                        />

                      </div>
                    </div>
                    <div className="col-md-4 gender-box">
                      <div className="form-group">
                        <label>جنسیت :</label>
                        <select name="gender"
                          id="gender"
                          className="form-control"
                          onChange={(e) => {
                            this.BindInput("FormData", "Gender", e.target)
                          }}
                        >
                          <option value="0">مرد</option>
                          <option value="1">زن</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <hr />
                    </div>
                    <div className="col-md-12">
                      <QuestionList />
                    </div>
                    <div className="col-md-12">
                      <button type="submit" className="btn btn-success">
                        ثبت
                      </button>
                    </div>
                    <div className="col-md-12 errors__container alert alert-danger"></div>
                  </div>
                }
              </form>
            }
          </React.Fragment>
     : <Result FormId="" /> } 
       </div>
    );
  }
}

var mapDispatchToProps = function (dispatch) {
  return {
    SubmitForm: data => dispatch(submitForm(data))
  };
}

const mapStateToProps = function (state) {
  return {
    Question: state.Survey.Questions,
    Answer: state.Survey.Answers
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestForm);



// WEBPACK FOOTER //
// ./src/Components/Requests/com.survey.form.jsx